// gatsby-browser.js
import React from 'react';
import 'isomorphic-fetch';
import analyticsApiClient from './src/utils/analyticsApiClient';
import PageWrapper from './src/PageWrapper';
import { I18nextProvider } from 'react-i18next';

// import the i18n factory and call it to get an initialized instance
import createI18n from './src/i18n/i18n';

// Initialize i18n instance (optional: pass options like { phrase: { projectId: '...' } })
const i18n = createI18n();

// expose for debugging in browser console (remove in production if concerned)
if (typeof window !== 'undefined') {
  window.i18next = i18n;
}

export const wrapRootElement = ({ element }) => (
  <I18nextProvider i18n={i18n}>{element}</I18nextProvider>
);

export const wrapPageElement = ({ element }) => (
  <>
    <PageWrapper element={element} />
  </>
);

export const onRouteUpdate = () => {
  const analytics = analyticsApiClient('spare-parts');
  analytics.sendPageview();
};